import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  Firebase,
  currentUserIsAdmin,
  getFourboxCategories,
} from '../../util';
import {
  getReportingAndEvaluationPeriodsForThisYear,
  getCurrentReportingAndEvaluationYear
} from '../../util/quarters';
import { OrganizationRef } from '../../util/refs';

import { Page } from '../shared';

import Select from 'react-select';

import { UpdateGoalsModal } from '../modals';

import { beginEditingGoals, endEditingGoals } from '../../actions/goals';

import Dropzone from 'react-dropzone';
import Switch from 'react-switch';

class SettingsPage extends Component {

  state = {
    uploading: false,
    uploadProgress: 0,
    configuringGoals: false,
    pageMessage: null,
    editingGoal: null
  }

  componentWillReceiveProps(nextProps){
    console.log('settings nextProps: ', nextProps);
  }

  //TODO abstract this out
  onDrop(acceptedFiles, rejectedFiles){
    //for accepted files, upload them
    _.each(acceptedFiles, file => {
      this.uploadFile(file);
    });
  }

  clearUploadProgress(){
    this.setState({
      uploading: false,
      uploadProgress: 0,
    });
  }

  onFileUploadSuccess(upload){
    //save logo to org object
    OrganizationRef().update({
      logoUrl: upload.downloadURL
    });
    setTimeout(this.clearUploadProgress.bind(this), 500);
  }

  uploadFile(file){

    this.setState({
      uploading: true
    });

    const storage = Firebase.storage();
    const fileUploadPath = this.props.organization._id + '/uploads/' + file.name;

    const uploadTask = storage.ref(fileUploadPath).put(file);
    const successFunction = this.onFileUploadSuccess.bind(this);

    //https://firebase.google.com/docs/storage/web/upload-files
    uploadTask.on('state_changed', snap => {

      const uploadProgress = (snap.bytesTransferred / snap.totalBytes) * 100;

      this.setState({
        uploadProgress
      });

      console.log('upload progress: ', uploadProgress);
    }, err => {
      //error
      this.setState({
        uploadError: err
      });
    }, () => {
      //success
      const lastModified = uploadTask.snap;

      uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
        uploadTask.snapshot.ref.getMetadata().then(metaData => {
          successFunction({
            fileName: file.name,
            fileSize: file.size,
            ref: fileUploadPath,
            lastModified: metaData.timeCreated,
            downloadURL,
          });
        });
      });
    });
  }

  toggleCustomGoals(){

    const currentValue = this.props.organization.customGoalsEnabled ? this.props.organization.customGoalsEnabled : false;

    OrganizationRef().update({
      customGoalsEnabled: !currentValue
    }).then(() => {
      this.onSettingUpdated();
    });
  }

  toggleNotificationsPaused(){
    const currentValue = this.props.organization.notificationsPaused ? this.props.organization.notificationsPaused : false;

    OrganizationRef().update({
      notificationsPaused: !currentValue
    }).then(() => {
      this.onSettingUpdated();
    });
  }

  renderConfigureGoalsButton(){
    const { sprintGoals } = this.props.organization || {};

    return (
      <div>
        <button onClick={() => { this.props.beginEditingGoals(sprintGoals); } } className="button primary">Configure Goals</button>
      </div>
    );
  }

  toggleProfileOption(optionName, optionValue){
    //profileOptions
    OrganizationRef().update({
      profileOptions: {
        ...this.props.organization.profileOptions,
        [optionName]: optionValue
      }
    }).then(() => {
      this.onSettingUpdated();
    });
  }

  updateOrganizationProp(prop = {}){
    OrganizationRef().update(prop).then(() => {
      this.onSettingUpdated();
    });
  }

  renderEmployeeProfileOptions(){
    const { tenureEnabled, educationEnabled, experienceEnabled, titleEnabled } = ((this.props.organization || {}).profileOptions || {});

    return (
      <form className="velocity-form" style={{backgroundColor: 'transparent', position: 'relative', float: 'left', clear: 'both', marginTop: '20px', padding: 0}}>

        <div className="form-group">

          <div className="input-group quarter-width switch-input-group">
            <label>Title</label>
            <Switch
              id="some-switch"
              checked={titleEnabled || false}
              onChange={checked => { this.toggleProfileOption('titleEnabled', checked); } }
              handleDiameter={20}
              offColor="#D2D2D2"
              onColor="#2D9542"
              offHandleColor="#545B72"
              onHandleColor="#FFFFFF"
              height={28}
              width={60}
              className="react-switch-input"
            />
          </div>

          <div className="input-group quarter-width switch-input-group">
            <label>Tenure</label>
            <Switch
              id="some-switch"
              checked={tenureEnabled || false}
              onChange={checked => { this.toggleProfileOption('tenureEnabled', checked); } }
              handleDiameter={20}
              offColor="#D2D2D2"
              onColor="#2D9542"
              offHandleColor="#545B72"
              onHandleColor="#FFFFFF"
              height={28}
              width={60}
              className="react-switch-input"
            />
          </div>

          <div className="input-group quarter-width switch-input-group">
            <label>Education</label>
            <Switch
              id="some-switch"
              checked={educationEnabled || false}
              onChange={checked => { this.toggleProfileOption('educationEnabled', checked); } }
              handleDiameter={20}
              offColor="#D2D2D2"
              onColor="#2D9542"
              offHandleColor="#545B72"
              onHandleColor="#FFFFFF"
              height={28}
              width={60}
              className="react-switch-input"
            />
          </div>

          <div className="input-group quarter-width switch-input-group">
            <label>Prior Sales Experience</label>
            <Switch
              id="some-switch"
              checked={experienceEnabled || false}
              onChange={checked => { this.toggleProfileOption('experienceEnabled', checked); } }
              handleDiameter={20}
              offColor="#D2D2D2"
              onColor="#2D9542"
              offHandleColor="#545B72"
              onHandleColor="#FFFFFF"
              height={28}
              width={60}
              className="react-switch-input"
            />
          </div>

        </div>

      </form>
    )
  }

  renderOrganizationOptions(){

    const { customGoalsEnabled, notificationsPaused } = this.props.organization || {};

    return (
      <form className="velocity-form" style={{backgroundColor: 'transparent', position: 'relative', float: 'left', clear: 'both', marginTop: '50px', padding: 0}}>

        <div className="form-group">
          <div className="input-group quarter-width switch-input-group">
            <label>Enable custom goal creation</label>
            <Switch
              id="some-switch"
              checked={customGoalsEnabled || false}
              onChange={checked => { this.toggleCustomGoals(); } }
              handleDiameter={20}
              offColor="#D2D2D2"
              onColor="#2D9542"
              offHandleColor="#545B72"
              onHandleColor="#FFFFFF"
              height={28}
              width={60}
              className="react-switch-input"
            />
          </div>

          <div className="input-group quarter-width switch-input-group">
            <label>Pause All Notifications</label>
            <Switch
              id="some-switch"
              checked={notificationsPaused || false}
              onChange={checked => { this.toggleNotificationsPaused(); } }
              handleDiameter={20}
              offColor="#D2D2D2"
              onColor="#2D9542"
              offHandleColor="#545B72"
              onHandleColor="#FFFFFF"
              height={28}
              width={60}
              className="react-switch-input"
            />
          </div>
        </div>

      </form>
    )
  }

  renderLogoUploadContainer(){

    const { logoUrl } = this.props.organization || {};
    const { uploadProgress, uploading } = this.state;

    return (
      <div className="upload-item-container">
        <Dropzone activeClassName='active' acceptClassName='uploading' multiple={false} className="upload-dropzone" onDrop={this.onDrop.bind(this)}>
          {logoUrl &&
            <img className="upload-item" src={logoUrl} />
          }
          {!logoUrl && !uploading &&
            <p className="no-upload-message">Drag & drop or <span className="action">click here</span> to upload</p>
          }
          {uploading &&
            <div className="upload-progress-container">
              <div className="upload-progress" style={{width: uploadProgress + '%' }}></div>
            </div>
          }
          {!uploading &&
            <label>Company Logo</label>
          }
        </Dropzone>
      </div>
    );
  }

  onSettingUpdated(){
    this.setState({
      pageMessage: {
        messageType: 'success',
        messageContent: 'Organization settings updated',
        expireAfter: 5000,
      }
    });
  }

  onGoalsUpdated(){
    this.props.endEditingGoals();
    this.setState({
      editingGoal: null,
      pageMessage: {
        messageType: 'success',
        messageContent: 'Organization goals updated',
        expireAfter: 5000,
      }
    });
  }

  organizationGoals(){
    const { sprintGoals } = (this.props.organization || {});

    return sprintGoals || [];
  }

  goalsForCategory(category){
    return _.filter(this.organizationGoals(), goal => {
      return goal.category === category;
    });
  }

  editGoal(goal){

    const { sprintGoals } = (this.props.organization || {});

    console.log('setting editing goal state: ', goal);

    this.setState({
      editingGoal: goal
    }, () => {
      this.props.beginEditingGoals(sprintGoals);
    });
  }

  renderGoal(goal){
    const goalShouldHaveDefinition = goal.category === 'behavior' || goal.category === 'skill';

    return(
      <div key={goal.id} className={'goal' + (goal.inactive ? ' inactive' : '')}>
        <div className="goal-name">{goal.name}{goal.inactive ? ' (Inactive)' : ''}</div>
        <div className="goal-description">Description: {goal.description}</div>
        {!goal.inactive && goalShouldHaveDefinition && goal.definition && goal.definition !== '' &&
          <div className="goal-definition">Definition: {goal.definition}</div>
        }
        {!goal.inactive && goalShouldHaveDefinition && (!goal.definition || goal.definition === '') &&
          <button onClick={() => { this.editGoal(goal); }} className="goal-definition-action button primary-outline button-micro">Add talent card definition</button>
        }
      </div>
    )
  }

  quarterOneStartMonthOffsetOptions(){
    return [{
      label: 'January',
      value: 0,
    },{
      label: 'February',
      value: 1,
    },{
      label: 'March',
      value: 2,
    },{
      label: 'April',
      value: 3,
    },{
      label: 'May',
      value: 4,
    },{
      label: 'June',
      value: 5,
    },{
      label: 'July',
      value: 6,
    },{
      label: 'August',
      value: 7,
    },{
      label: 'September',
      value: 8,
    },{
      label: 'October',
      value: 9,
    },{
      label: 'November',
      value: 10,
    },{
      label: 'December',
      value: 11,
    }]
  }

  evaluationPeriodStartOffsetOptions(){
    return [{
      label: 'the week of',
      value: 0
    },{
      label: 'the week after',
      value: 1
    }];
  }

  evaluationPeriodDurationOptions(){
    return [{
      label: '1 week',
      value: 1
    },{
      label: '2 weeks',
      value: 2
    },{
      label: '3 weeks',
      value: 3
    },{
      label: '4 weeks',
      value: 4
    }];
  }

  render(){

    let { evaluationPeriodStartOffset, evaluationPeriodDuration, quarterOneStartMonthOffset } = this.props.organization || {};

    evaluationPeriodStartOffset = evaluationPeriodStartOffset || 0;
    evaluationPeriodDuration = evaluationPeriodDuration || 1;
    quarterOneStartMonthOffset = quarterOneStartMonthOffset || 0;

    const reportingAndEvaluationPeriodsForThisYear = getReportingAndEvaluationPeriodsForThisYear();

    if(!currentUserIsAdmin()){
      return (
        <Page
          pageClass="settings"
          loading={!this.props.organization}
          pageMessage={this.state.pageMessage}
          clearMessage={() => { this.setState({ pageMessage: null }) }}
        >
          <div className="page-title">
            <h1>Settings</h1>
          </div>
          <div className="page-content">
            <div className="page-section">User settings page coming soon.</div>
          </div>
        </Page>
      );
    }

    //<div className="evaluation-period-divider">the last full week of the quarter.</div>

    return (
      <Page
        pageClass="settings"
        hideSidebar={true}
        loading={!this.props.organization}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
      >
        <div className="page-title">
          <h1>Organization Settings</h1>
        </div>
        <div className="page-content">
          <div className="page-section">
            <div className="section-header">Organzation Options</div>
            {currentUserIsAdmin() && this.renderLogoUploadContainer()}
            {currentUserIsAdmin() && this.renderOrganizationOptions()}
          </div>

          <div className="page-section">
            <div className="section-header">Employee Profile</div>
            {currentUserIsAdmin() && this.renderEmployeeProfileOptions()}
          </div>
        </div>
        <div className="page-divider"></div>
        <div className="page-title">
          <h1>Quarterly Reporting/Evaluation Periods</h1>
          <p>Each quarter's evaluation period is when weekly velocity sprint reports are paused to give managers and emplyoees time to complete their quarterly evaluation and set up next quarter's goals.</p>
          <div className="evaluation-period-container">
            <p>First Quarter begins in </p>
            <Select
              placeholder="..."
              classNamePrefix={'react-select'}
              className='react-select-container evaluation-period'
              value={_.find(this.quarterOneStartMonthOffsetOptions(), option => { return option.value === quarterOneStartMonthOffset })}
              options={this.quarterOneStartMonthOffsetOptions()}
              onChange={(option) => { this.updateOrganizationProp({ quarterOneStartMonthOffset: option.value }); }}
              isSearchable={false}
            />
          <br/>
            <p>Evaluation period begins </p>
              <Select
                placeholder="..."
                classNamePrefix={'react-select'}
                className='react-select-container evaluation-period'
                value={_.find(this.evaluationPeriodStartOffsetOptions(), option => { return option.value === evaluationPeriodStartOffset })}
                options={this.evaluationPeriodStartOffsetOptions()}
                onChange={(option) => { this.updateOrganizationProp({ evaluationPeriodStartOffset: option.value }); }}
                isSearchable={false}
              />
            <div className="evaluation-period-divider">the last day the quarter.</div>
            <br/>
            <p>Evaluation period lasts </p>
              <Select
                placeholder="..."
                classNamePrefix={'react-select'}
                className='react-select-container evaluation-period'
                value={_.find(this.evaluationPeriodDurationOptions(), option => { return option.value === evaluationPeriodDuration })}
                options={this.evaluationPeriodDurationOptions()}
                onChange={(option) => { this.updateOrganizationProp({ evaluationPeriodDuration: option.value }); }}
                isSearchable={false}
              />
          </div>
          <div>
            <h3 style={{marginBottom: '10px'}}>{getCurrentReportingAndEvaluationYear()} reporting & evaluation periods*</h3>

            {_.map(['1', '2', '3', '4'], quarterNumber => {

              const quarterName = `q${quarterNumber}`;
              const thisQuarter = reportingAndEvaluationPeriodsForThisYear[quarterName];
              const isCurrent = thisQuarter.isCurrent;

              return(
                <div key={`quarter-${quarterNumber}`} className={'reporting-period' + (isCurrent ? ' current' : '')}>
                  {isCurrent &&
                    <h6>CURRENT QUARTER ({thisQuarter.status.toUpperCase()})</h6>
                  }
                  <p>Quarter {quarterNumber} reporting period: <b>{thisQuarter.reportingDates.start.format('M/D/YY')}</b> to <b>{thisQuarter.reportingDates.end.format('M/D/YY')}</b> <small>({thisQuarter.reportingDates.numWeeks} weeks)</small><br/>Quarter {quarterNumber} evaluation period: <b>{thisQuarter.evaluationDates.start.format('M/D/YY')}</b> to <b>{thisQuarter.evaluationDates.end.format('M/D/YY')}</b> <small>({thisQuarter.evaluationDates.numWeeks} {thisQuarter.evaluationDates.numWeeks > 1 ? 'weeks' : 'week'})</small></p>
                </div>
              )
            })}

            <p><small>*Employees are able to complete initial talent evaluation outside of evaluation period</small></p>
          </div>
        </div>
        <div className="page-divider"></div>
        <div className="page-title">
          <h1>Organization Goals</h1>
        </div>
        <div className="page-content">
          <div className="page-section">
            {currentUserIsAdmin() && this.renderConfigureGoalsButton()}
            <div className="organization-goals">
              {_.map(getFourboxCategories(true), category => {
                return (
                  <div key={category.key} className="goal-category">
                    <div className="goals-section-header">{category.name}</div>
                    {_.map(this.goalsForCategory(category.key), this.renderGoal.bind(this))}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <UpdateGoalsModal editingGoal={this.state.editingGoal} onSave={this.onGoalsUpdated.bind(this)} />
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    organization: state.organization.data,
  }
}

export default connect(mapStateToProps, { beginEditingGoals, endEditingGoals })(SettingsPage);



// WEBPACK FOOTER //
// ./src/components/settings/index.js